/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M6 18L18 18M6 14H18"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M14 10L18 10M14 6H18M8 10V6M8 6H6M8 6H10M10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V10C22 7.19974 22 5.79961 21.455 4.73005C20.9757 3.78924 20.2108 3.02433 19.27 2.54497C18.2004 2 16.8003 2 14 2H10C7.19974 2 5.79961 2 4.73005 2.54497C3.78924 3.02433 3.02433 3.78924 2.54497 4.73005C2 5.79961 2 7.19974 2 10V14C2 16.8003 2 18.2004 2.54497 19.27C3.02433 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<rect
				opacity="0.12"
				x="2"
				y="2"
				width="20"
				height="20"
				rx="5"
				fill="currentColor"
			/>
			<path
				d="M6 18L18 18M14 10L18 10M14 6L18 6M6 14H18M8 10V6M8 6H6M8 6H10M10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V10C22 7.19974 22 5.79961 21.455 4.73005C20.9757 3.78924 20.2108 3.02433 19.27 2.54497C18.2004 2 16.8003 2 14 2H10C7.19974 2 5.79961 2 4.73005 2.54497C3.78924 3.02433 3.02433 3.78924 2.54497 4.73005C2 5.79961 2 7.19974 2 10V14C2 16.8003 2 18.2004 2.54497 19.27C3.02433 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M3.98005 1.79497C5.04961 1.25 6.44974 1.25 9.25 1.25L14.75 1.25C17.5503 1.25 18.9504 1.25 20.02 1.79497C20.9608 2.27434 21.7257 3.03924 22.205 3.98005C22.75 5.04961 22.75 6.44974 22.75 9.25L22.75 14.75L22.75 14.75C22.75 17.5503 22.75 18.9504 22.205 20.02C21.7257 20.9608 20.9608 21.7257 20.02 22.205C18.9504 22.75 17.5503 22.75 14.75 22.75L9.25 22.75C6.44974 22.75 5.04961 22.75 3.98005 22.205C3.03924 21.7257 2.27433 20.9608 1.79497 20.02C1.25 18.9504 1.25 17.5503 1.25 14.75L1.25 9.25C1.25 6.44974 1.25 5.04961 1.79497 3.98005C2.27433 3.03924 3.03924 2.27434 3.98005 1.79497ZM6.0001 5.24995C5.58589 5.24995 5.2501 5.58574 5.2501 5.99995C5.2501 6.41416 5.58589 6.74995 6.0001 6.74995L7.2501 6.74995L7.2501 9.99995C7.2501 10.4142 7.58589 10.7499 8.0001 10.7499C8.41431 10.7499 8.7501 10.4142 8.7501 9.99995L8.7501 6.74995L10.0001 6.74995C10.4143 6.74995 10.7501 6.41416 10.7501 5.99995C10.7501 5.58574 10.4143 5.24995 10.0001 5.24995L8.0001 5.24995L6.0001 5.24995ZM14.0001 5.25004C13.5859 5.25004 13.2501 5.58582 13.2501 6.00003C13.2501 6.41425 13.5859 6.75004 14.0001 6.75004L18.0001 6.75004C18.4143 6.75004 18.7501 6.41425 18.7501 6.00004C18.7501 5.58582 18.4143 5.25004 18.0001 5.25004L14.0001 5.25004ZM14.0001 9.25004C13.5859 9.25004 13.2501 9.58582 13.2501 10C13.2501 10.4142 13.5859 10.75 14.0001 10.75L18.0001 10.75C18.4143 10.75 18.7501 10.4142 18.7501 10C18.7501 9.58582 18.4143 9.25004 18.0001 9.25004L14.0001 9.25004ZM6.00011 13.25C5.5859 13.25 5.25011 13.5858 5.25011 14C5.25011 14.4142 5.5859 14.75 6.00011 14.75L18.0001 14.75C18.4143 14.75 18.7501 14.4142 18.7501 14C18.7501 13.5858 18.4143 13.25 18.0001 13.25L6.00011 13.25ZM6.00011 17.25C5.5859 17.25 5.25011 17.5858 5.25011 18C5.25011 18.4142 5.5859 18.75 6.00011 18.75L18.0001 18.75C18.4143 18.75 18.7501 18.4143 18.7501 18C18.7501 17.5858 18.4143 17.25 18.0001 17.25L6.00011 17.25Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M9.5 2L9 2V2C7.13872 2 6.20808 2 5.45492 2.24472C3.93273 2.73931 2.73931 3.93273 2.24472 5.45492C2 6.20808 2 7.13872 2 9L2 14C2 16.8003 2 18.2004 2.54497 19.27C3.02434 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V9C22 7.13872 22 6.20808 21.7553 5.45492C21.2607 3.93273 20.0673 2.73931 18.5451 2.24472C17.7919 2 16.8613 2 15 2V2L14.5 2M6 18L18 18M14 10L18 10M14 6L18 6M6 14H18M8 10V6M8 6H6M8 6H10"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M6 18L18 18M14 10L18 10M14 6L18 6M6 14H18M8 10V6M8 6H6M8 6H10M10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V10C22 7.19974 22 5.79961 21.455 4.73005C20.9757 3.78924 20.2108 3.02433 19.27 2.54497C18.2004 2 16.8003 2 14 2H10C7.19974 2 5.79961 2 4.73005 2.54497C3.78924 3.02433 3.02433 3.78924 2.54497 4.73005C2 5.79961 2 7.19974 2 10V14C2 16.8003 2 18.2004 2.54497 19.27C3.02433 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				d="M9.25 1.25C6.44974 1.25 5.04961 1.25 3.98005 1.79497C3.03924 2.27433 2.27433 3.03924 1.79497 3.98005C1.25 5.04961 1.25 6.44974 1.25 9.25V14.75C1.25 17.5503 1.25 18.9504 1.79497 20.02C2.27433 20.9608 3.03924 21.7257 3.98005 22.205C5.04961 22.75 6.44974 22.75 9.25 22.75H14.75C17.5503 22.75 18.9504 22.75 20.02 22.205C20.9608 21.7257 21.7257 20.9608 22.205 20.02C22.75 18.9504 22.75 17.5503 22.75 14.75V9.25C22.75 6.44974 22.75 5.04961 22.205 3.98005C21.7257 3.03924 20.9608 2.27433 20.02 1.79497C18.9504 1.25 17.5503 1.25 14.75 1.25H9.25Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M5.25 6C5.25 5.58579 5.58579 5.25 6 5.25L8 5.25L10 5.25C10.4142 5.25 10.75 5.58579 10.75 6C10.75 6.41421 10.4142 6.75 10 6.75L8.75 6.75L8.75 10C8.75 10.4142 8.41421 10.75 8 10.75C7.58579 10.75 7.25 10.4142 7.25 10L7.25 6.75L6 6.75C5.58579 6.75 5.25 6.41421 5.25 6ZM13.25 6.00009C13.25 5.58587 13.5858 5.25009 14 5.25009L18 5.25009C18.4142 5.25009 18.75 5.58587 18.75 6.00009C18.75 6.4143 18.4142 6.75009 18 6.75009L14 6.75009C13.5858 6.75009 13.25 6.4143 13.25 6.00009ZM13.25 10.0001C13.25 9.58587 13.5858 9.25009 14 9.25009L18 9.25009C18.4142 9.25009 18.75 9.58587 18.75 10.0001C18.75 10.4143 18.4142 10.7501 18 10.7501L14 10.7501C13.5858 10.7501 13.25 10.4143 13.25 10.0001ZM5.25001 14.0001C5.25001 13.5859 5.5858 13.2501 6.00001 13.2501L18 13.2501C18.4142 13.2501 18.75 13.5859 18.75 14.0001C18.75 14.4143 18.4142 14.7501 18 14.7501L6.00001 14.7501C5.5858 14.7501 5.25001 14.4143 5.25001 14.0001ZM5.25001 18.0001C5.25001 17.5859 5.5858 17.2501 6.00001 17.2501L18 17.2501C18.4142 17.2501 18.75 17.5859 18.75 18.0001C18.75 18.4143 18.4142 18.7501 18 18.7501L6.00001 18.7501C5.5858 18.7501 5.25001 18.4143 5.25001 18.0001Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
